<template>
  <div class="tags-wrapper">
    <div class="title">{{ title }}</div>
    <div class="tags">
      <slot />
    </div>
  </div>
</template>

<script>
  export default {
    props: [
      'title'
    ]
  }
</script>

<style lang="scss" scoped>
  .tags-wrapper {
    @apply
      py-2
      px-1
      flex
      w-full;

    .title {
      @apply
        mt-1
        text-xs
        flex-grow-0
        flex-shrink-0
        text-ctm-primary;
    }

    .tags {
      @apply
        ml-0.5
        w-full
        -mx-0.5
        -my-0.5;
    }
  }
</style>